// extracted by mini-css-extract-plugin
export default {"wrapperTurkishPayFixCheckbox":"TurkishPayFix_wrapperTurkishPayFixCheckbox__VNQ6D","checkbox":"TurkishPayFix_checkbox__ezJZt"};